if (!customElements.get('pp-hero-slideshow')) {
  customElements.define('pp-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.controls = this.querySelector('[data-controls]');
      if (this.slides.length < 2 || !this.controls) return;
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.dataset.designMode === 'true';
      this.hovered = false;
      this.focused = false;
      this.controls.hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelectorAll('[data-go]').forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.go)), options));
      this.querySelector('[data-toggle]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.focused = false;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.querySelector(`[data-go="${this.index}"]`).focus();
        }
      }, options);
      const viewport = this.querySelector('.pp-hero-slides');
      viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY };
      }, options);
      viewport.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
      }, options);
      viewport.addEventListener('pointercancel', () => { this.touchStart = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updateToggle();
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        this.paused = true;
        this.updateToggle();
        this.show(index);
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.offscreen = !entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.updateToggle();
      this.show(0);
    }
    show(index) {
      const previous = this.slides[this.index];
      if (previous?.contains(document.activeElement)) this.querySelector('[data-next]').focus();
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.querySelectorAll('[data-go]').forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
      this.schedule();
    }
    updateToggle() {
      this.querySelector('[data-toggle]').setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.querySelector('[data-pause-icon]').hidden = this.paused;
      this.querySelector('[data-play-icon]').hidden = !this.paused;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || this.offscreen || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
